import type { AsyncState } from './async-state.interface'

export const createStateFlags = (
  state: AsyncState
): { isIdle: boolean; isPending: boolean; isDone: boolean; isError: boolean } => ({
  isIdle: state === 'idle',
  isPending: state === 'pending',
  isDone: state === 'done',
  isError: state === 'error',
})

export const toError = (err: unknown): Error => {
  if (err instanceof Error) {
    return err
  }
  return new Error(String(err))
}
